import { CancelSaveButtons } from '@components/cancel-save-buttons';
import { createForm, useCreateFormStore } from '@components/form';
import { hideModal, Modal, useModal } from '@components/modal';
import { useScopedTranslate } from '@locale/translate';

import { useDuplicateIntegration } from 'api/integrations/hooks';
import { DuplicateIntegrationData, Integration } from 'api/integrations/requests';

export const useDuplicateIntegrationModal = () => useModal(DuplicateIntegrationModal);

const Form = createForm<DuplicateIntegrationData>();

export const DuplicateIntegrationModal = ({ integration }: { integration: Integration }) => {
  const { t } = useScopedTranslate(locale);
  const formStore = useCreateFormStore();

  const duplicateMutation = useDuplicateIntegration(integration);

  const handleSubmit = async () => {
    await duplicateMutation.mutateAsync(formStore.getState().values as DuplicateIntegrationData);
    hideModal();
  };

  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} />
      <Modal.Content>
        <Form store={formStore} onSubmit={handleSubmit}>
          <Form.TextField
            id="name"
            label={t('integrationName')}
            defaultValue={`${integration.name} [${t('copy')}]`}
          />
        </Form>
      </Modal.Content>
      <Modal.Footer>
        <CancelSaveButtons
          alwaysShow
          onCancel={hideModal}
          onSave={handleSubmit}
          translationsOverride={{ save: t('confirm') }}
          isDisabled={duplicateMutation.isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};

export const locale = {
  en: {
    title: 'Duplicate integration',
    integrationName: 'Integration name',
    copy: 'copy',
    confirm: 'Duplicate',
  },
};
